import AuditLogsTab from './AuditLogsTab';

export default function AuditLogs() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Audit Logs
          </h1>
          <p className="text-base md:text-lg text-gray-600">
            View all system activity and changes across packs, cells, customers, and tests
          </p>
        </div>
      </div>
      <AuditLogsTab />
    </div>
  );
}
